import React from 'react';
import { MarcomAppFooter } from '@shared/components/Marcom/AppFooter';
import { ShopStorefrontProvider } from '@apps/registry/common/components/Catalog/components/ShopStorefrontProvider';

// Marketing footer for the public Save the Date gallery. Kept in its own chunk
// (see SaveTheDateMarcomFooter.lazy) so the Marcom + storefront module graphs
// stay out of the shared DesignsGallery bundle for all other categories/routes.
export const SaveTheDateMarcomFooter = () => (
  <ShopStorefrontProvider>
    <MarcomAppFooter />
  </ShopStorefrontProvider>
);
